import React from 'react';
import { Handle, Position } from '@xyflow/react';
import Icon from '../../../ui/Icon';

export default function ActionNode({ data }) {
  return (
    <div
      style={{
        background: '#FFFFFF',
        border: '1px solid #DDE1E7',
        borderRadius: 10,
        padding: '10px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        minWidth: 180,
        maxWidth: 220,
        boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        style={{ width: 8, height: 8, background: '#718096', border: '2px solid #fff' }}
      />
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          background: '#3b82f6',
          display: 'grid',
          placeItems: 'center',
          flexShrink: 0,
          boxShadow: '0 1px 4px rgba(59,130,246,0.35)',
        }}
      >
        <Icon name="promote" size={16} color="#fff" />
      </div>
      <div style={{ fontSize: 12, fontWeight: 500, color: '#2D3748', lineHeight: 1.3 }}>
        {data.label || 'Action'}
      </div>
      
      {data.isApproval ? (
        <>
          {/* APPROVED Handle */}
          <div style={{ position: 'absolute', right: -70, top: '25%', fontSize: 10, fontWeight: 700, color: '#3B5BDB' }}>APPROVED</div>
          <Handle
            type="source"
            position={Position.Right}
            id="approved"
            style={{ width: 8, height: 8, background: '#3B5BDB', border: '2px solid #fff', top: '30%' }}
          />
          {/* REJECTED Handle */}
          <div style={{ position: 'absolute', right: -70, top: '65%', fontSize: 10, fontWeight: 700, color: '#dc2626' }}>REJECTED</div>
          <Handle
            type="source"
            position={Position.Right}
            id="rejected"
            style={{ width: 8, height: 8, background: '#dc2626', border: '2px solid #fff', top: '70%' }}
          />
        </>
      ) : (
        <Handle
          type="source"
          position={Position.Right}
          style={{ width: 8, height: 8, background: '#718096', border: '2px solid #fff' }}
        />
      )}
    </div>
  );
}
